(function () {
  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  function closest(el, selector) {
    if (!el) return null;
    return el.closest(selector);
  }

  function parseJson(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  function parseBoolean(value, fallback) {
    if (typeof value === "boolean") return value;
    if (value === "true") return true;
    if (value === "false") return false;
    return fallback;
  }

  function parseInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  var NEWSLETTER_DISMISSED_COOKIE = "soksi_newsletter_popup_dismissed";
  var NEWSLETTER_SUBMITTED_COOKIE = "soksi_newsletter_popup_submitted";

  function getCookie(name) {
    var encodedName = encodeURIComponent(name) + "=";
    var cookies = document.cookie ? document.cookie.split(";") : [];

    for (var i = 0; i < cookies.length; i += 1) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(encodedName) === 0) {
        return decodeURIComponent(cookie.slice(encodedName.length));
      }
    }

    return "";
  }

  function setCookie(name, value, days) {
    var durationDays = Math.max(1, parseInteger(days, 1));
    var maxAge = durationDays * 24 * 60 * 60;
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + "; max-age=" + maxAge + "; path=/; SameSite=Lax";
    return getCookie(name) === value;
  }

  function hasSessionFlag(name) {
    try {
      var raw = window.sessionStorage.getItem(name);
      if (!raw) return false;
      var expiresAt = parseInteger(raw, 0);
      if (expiresAt && Date.now() > expiresAt) {
        window.sessionStorage.removeItem(name);
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  function setSessionFlag(name, days) {
    try {
      var durationDays = Math.max(1, parseInteger(days, 1));
      window.sessionStorage.setItem(name, String(Date.now() + durationDays * 24 * 60 * 60 * 1000));
      return true;
    } catch (err) {
      return false;
    }
  }

  function hasPopupFlag(name) {
    return getCookie(name) === "1" || hasSessionFlag(name);
  }

  function setPopupFlag(name, days) {
    if (!setCookie(name, "1", days)) {
      setSessionFlag(name, days);
    }
  }

  function shuffleInPlace(items) {
    for (var i = items.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = items[i];
      items[i] = items[j];
      items[j] = temp;
    }
    return items;
  }

  function getGridColumnCount(grid) {
    if (!grid) return 1;
    var templateColumns = window.getComputedStyle(grid).getPropertyValue("grid-template-columns");
    if (!templateColumns || templateColumns === "none") return 1;

    var columns = templateColumns
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;

    return Math.max(1, columns);
  }

  function setupMobileMenu() {
    var toggle = document.querySelector("[data-soksi-menu-toggle]");
    if (!toggle) return;
    var panel = document.getElementById("soksi-mobile-panel");
    var accordionDetails = panel ? Array.prototype.slice.call(panel.querySelectorAll(".soksi-mobile-menu-group details")) : [];
    var ACCORDION_ANIMATION_MS = 550;
    var ACCORDION_CLOSE_PADDING = "0 16px";
    var ACCORDION_TRANSITION = "max-height " + ACCORDION_ANIMATION_MS + "ms ease, padding-block " + ACCORDION_ANIMATION_MS + "ms ease, opacity " + ACCORDION_ANIMATION_MS + "ms ease";

    function setAccordionTransition(content) {
      if (!content) return;
      content.style.transition = ACCORDION_TRANSITION;
    }

    function isAccordionOpen(details) {
      if (!details) return false;
      return details.getAttribute("data-soksi-accordion-state") === "open";
    }

    function setAccordionState(details, isOpen, finalize) {
      if (!details) return;

      details.setAttribute("data-soksi-accordion-state", isOpen ? "open" : "closed");
      details.classList.toggle("is-open", isOpen);

      if (finalize) {
        details.open = isOpen;
      }

      var summary = details.querySelector("summary");
      if (summary) {
        summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }
    }

    function clearAccordionTransitionEnd(details) {
      if (!details || !details._soksiTransitionEndHandler) return;
      var content = details.querySelector(".details-content");
      if (content) {
        content.removeEventListener("transitionend", details._soksiTransitionEndHandler);
      }
      details._soksiTransitionEndHandler = null;
    }

    function closeAfterAnimation(details) {
      if (!details || details._soksiDesiredState !== "closed" || !details._soksiAnimatingClose) return;

      details._soksiAnimatingClose = false;
      setAccordionState(details, false, true);
    }

    function forceCloseAccordion(details) {
      if (!details) return;

      if (details._soksiCloseTimeout) {
        clearTimeout(details._soksiCloseTimeout);
        details._soksiCloseTimeout = null;
      }

      clearAccordionTransitionEnd(details);
      details._soksiDesiredState = "closed";
      details._soksiAnimatingClose = false;
      details.open = false;
      setAccordionState(details, false);

      var content = details.querySelector(".details-content");
      if (!content) return;

      content.style.transition = "";
      content.style.maxHeight = "0px";
      content.style.opacity = "0";
      content.style.paddingBlock = "0";
      content.style.pointerEvents = "none";
    }

    function openAccordion(details) {
      if (!details) return;
      var content = details.querySelector(".details-content");
      if (!content) return;

      if (details._soksiCloseTimeout) {
        clearTimeout(details._soksiCloseTimeout);
        details._soksiCloseTimeout = null;
      }

      setAccordionTransition(content);
      details._soksiDesiredState = "open";
      details._soksiAnimatingClose = false;
      clearAccordionTransitionEnd(details);
      setAccordionState(details, true);
      details.open = true;
      content.style.pointerEvents = "auto";
      content.style.opacity = "0";
      content.style.paddingBlock = "0";
      content.style.maxHeight = "0px";

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (details._soksiDesiredState !== "open") return;
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.opacity = "1";
          content.style.paddingBlock = ACCORDION_CLOSE_PADDING;
        });
      });
    }

    function closeAccordion(details) {
      if (!details) return;
      var content = details.querySelector(".details-content");
      if (!content) return;

      details._soksiDesiredState = "closed";
      setAccordionState(details, false);

      setAccordionTransition(content);
      details._soksiAnimatingClose = true;
      clearAccordionTransitionEnd(details);

      details.open = true;
      content.style.pointerEvents = "none";
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.opacity = "1";
      content.style.paddingBlock = ACCORDION_CLOSE_PADDING;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (details._soksiDesiredState !== "closed") return;
          content.style.maxHeight = "0px";
          content.style.opacity = "0";
          content.style.paddingBlock = "0";
        });
      });

      var onTransitionEnd = function (event) {
        if (event.target !== content || event.propertyName !== "max-height") return;
        closeAfterAnimation(details);
      };

      content.addEventListener("transitionend", onTransitionEnd, { once: true });
      details._soksiTransitionEndHandler = onTransitionEnd;

      details._soksiCloseTimeout = setTimeout(function () {
        details._soksiCloseTimeout = null;
        if (details._soksiDesiredState !== "closed" || !details._soksiAnimatingClose) return;
        closeAfterAnimation(details);
      }, ACCORDION_ANIMATION_MS);
    }

    function setAccordionDefaults() {
      accordionDetails.forEach(function (details) {
        forceCloseAccordion(details);
      });
    }

    function setPanelInteractivity(isOpen) {
      if (!panel) return;
      panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
      if (isOpen) {
        panel.removeAttribute("inert");
      } else {
        panel.setAttribute("inert", "");
      }
      if ("inert" in panel) {
        panel.inert = !isOpen;
      }
    }

    function setMenuState(isOpen) {
      document.documentElement.classList.toggle("menuout", isOpen);
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      toggle.setAttribute(
        "aria-label",
        isOpen ? toggle.getAttribute("data-soksi-menu-label-close") || "Close menu" : toggle.getAttribute("data-soksi-menu-label-open") || "Open menu"
      );
      setPanelInteractivity(isOpen);
      if (document.body) {
        document.body.classList.toggle("soksi-menu-locked", isOpen);
      }

      if (!isOpen) {
        setAccordionDefaults();
      }
    }

    toggle.addEventListener("click", function () {
      var shouldOpen = !document.documentElement.classList.contains("menuout");
      setMenuState(shouldOpen);
    });

    document.addEventListener("click", function (event) {
      var isInsideHeader = closest(event.target, ".soksi-header");
      if (!isInsideHeader) {
        setMenuState(false);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setMenuState(false);
      }
    });

    if (panel) {
      panel.addEventListener("click", function (event) {
        if (event.target === panel) {
          setMenuState(false);
        }
      });
    }

    accordionDetails.forEach(function (details) {
      var summary = details.querySelector("summary");
      if (!summary) return;

      forceCloseAccordion(details);

      summary.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var shouldOpen = !isAccordionOpen(details);
        if (shouldOpen) {
          accordionDetails.forEach(function (otherDetails) {
            if (otherDetails !== details && isAccordionOpen(otherDetails)) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  closeAccordion(otherDetails);
                });
              });
            }
          });
        }

        if (shouldOpen) {
          openAccordion(details);
        } else {
          closeAccordion(details);
        }
      }, true);
    });

    window.addEventListener("resize", function () {
      accordionDetails.forEach(function (details) {
        if (isAccordionOpen(details)) {
          openAccordion(details);
        }
      });
    });

    document.querySelectorAll(".soksi-mobile-panel a, .soksi-mobile-panel button").forEach(function (el) {
      el.addEventListener("click", function (event) {
        if (closest(event.target, "[data-soksi-menu-preserve]")) return;
        setMenuState(false);
      });
    });

    var desktopQuery = window.matchMedia("(min-width: 990px)");
    var onDesktopChange = function (event) {
      if (event.matches) {
        setMenuState(false);
      }
    };
    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", onDesktopChange);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(onDesktopChange);
    }

    setMenuState(false);
  }

  function setupLocalizationDropdown() {
    document.querySelectorAll("[data-soksi-localization]").forEach(function (wrap) {
      var trigger = wrap.querySelector("[data-soksi-localization-toggle]");
      var panel = wrap.querySelector("[data-soksi-localization-panel]");
      if (!trigger || !panel) return;

      function closePanel() {
        wrap.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
        panel.hidden = true;
      }

      function openPanel() {
        wrap.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        panel.hidden = false;
      }

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (wrap.classList.contains("is-open")) {
          closePanel();
        } else {
          openPanel();
        }
      });

      document.addEventListener("click", function (event) {
        if (!closest(event.target, "[data-soksi-localization]")) {
          closePanel();
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closePanel();
          trigger.focus();
        }
      });
    });
  }

  function setupLocalizationRecommendation() {
    var root = document.querySelector("[data-soksi-localization-recommendation]");
    if (!root || root.dataset.designMode === "true") return;

    var cookieName = "soksi_localization_recommendation_dismissed";
    if (getCookie(cookieName) === "1") return;

    var currentCountry = (root.dataset.currentCountry || "").toUpperCase();
    var currentLanguage = (root.dataset.currentLanguage || "").toLowerCase();
    var body = root.querySelector("[data-soksi-localization-recommendation-body]");
    var accept = root.querySelector("[data-soksi-localization-accept]");
    var dismiss = root.querySelector("[data-soksi-localization-dismiss]");
    var countryInput = root.querySelector("[data-soksi-localization-country-input]");
    var languageInput = root.querySelector("[data-soksi-localization-language-input]");
    var form = root.querySelector("form");

    if (!body || !accept || !dismiss || !form) return;

    function fieldValue(object, fields) {
      if (!object || typeof object !== "object") return "";

      for (var i = 0; i < fields.length; i += 1) {
        var value = object[fields[i]];
        if (typeof value === "string" && value) return value;
      }

      return "";
    }

    function normalizeCountry(country) {
      if (!country) return null;
      if (typeof country === "string") {
        return { value: country.toUpperCase(), label: country.toUpperCase() };
      }

      var value = fieldValue(country, ["iso_code", "isoCode", "code", "handle"]).toUpperCase();
      var label = fieldValue(country, ["name", "label", "endonym_name", "endonymName"]) || value;

      return value ? { value: value, label: label } : null;
    }

    function normalizeLanguage(language) {
      if (!language) return null;
      if (typeof language === "string") {
        return { value: language.toLowerCase(), label: language.toUpperCase() };
      }

      var value = fieldValue(language, ["iso_code", "isoCode", "locale", "code", "handle"]).toLowerCase();
      var label = fieldValue(language, ["endonym_name", "endonymName", "name", "label"]) || value.toUpperCase();

      return value ? { value: value, label: label } : null;
    }

    function recommendationText(country, language) {
      if (country && language) {
        return (root.dataset.templateCountryLanguage || "").replace("[country]", country.label).replace("[language]", language.label);
      }

      if (country) {
        return (root.dataset.templateCountry || "").replace("[country]", country.label);
      }

      if (language) {
        return (root.dataset.templateLanguage || "").replace("[language]", language.label);
      }

      return "";
    }

    function dismissForLater() {
      setCookie(cookieName, "1", root.dataset.dismissDays || 7);
      root.hidden = true;
    }

    function suggestionFromResponse(payload) {
      var suggestions = payload && Array.isArray(payload.suggestions) ? payload.suggestions : [];
      var firstSuggestion = suggestions.length ? suggestions[0] : {};
      var parts = firstSuggestion && firstSuggestion.parts ? firstSuggestion.parts : {};
      var flatSuggestion = payload && payload.suggestions && !Array.isArray(payload.suggestions) ? payload.suggestions : {};
      var country = normalizeCountry(parts.country || flatSuggestion.country || payload.country);
      var language = normalizeLanguage(parts.language || flatSuggestion.language || payload.language);

      if (country && country.value === currentCountry) country = null;
      if (language && language.value === currentLanguage) language = null;

      return { country: country, language: language };
    }

    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    if (base.slice(-1) !== "/") base += "/";
    var url = new URL(base + "browsing_context_suggestions.json", window.location.origin);

    if (currentCountry) {
      url.searchParams.set("country[enabled]", "true");
      url.searchParams.set("country[exclude]", currentCountry);
    }

    if (currentLanguage) {
      url.searchParams.set("language[enabled]", "true");
      url.searchParams.set("language[exclude]", currentLanguage);
    }

    fetch(url.toString(), { headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("Localization recommendation unavailable");
        return response.json();
      })
      .then(function (payload) {
        var suggestion = suggestionFromResponse(payload);
        var text = recommendationText(suggestion.country, suggestion.language);

        if (!text) return;

        body.textContent = text;
        root.hidden = false;

        accept.addEventListener("click", function () {
          if (suggestion.country && countryInput) {
            countryInput.value = suggestion.country.value;
          }

          if (suggestion.language && languageInput) {
            languageInput.value = suggestion.language.value;
          }

          dismissForLater();
          form.submit();
        });
      })
      .catch(function () {});

    dismiss.addEventListener("click", dismissForLater);
  }

  function setupMarketLocalizationModal() {
    document.querySelectorAll("[data-soksi-market-localization]").forEach(function (root) {
      var dialog = root.querySelector("[data-soksi-market-localization-modal]");
      var openButton = root.querySelector("[data-soksi-market-localization-open]");
      var closeButtons = Array.prototype.slice.call(root.querySelectorAll("[data-soksi-market-localization-close]"));
      var form = root.querySelector("form");
      var countryInput = root.querySelector("[data-soksi-market-localization-country-input]");
      var languageInput = root.querySelector("[data-soksi-market-localization-language-input]");
      var list = root.querySelector("[data-soksi-market-localization-list]");
      var flatList = root.querySelector("[data-soksi-market-localization-flat-list]");
      if (!dialog || !openButton || !form || !countryInput || !languageInput) return;

      if (list && flatList) {
        var rows = Array.prototype.slice.call(flatList.querySelectorAll("[data-soksi-market-localization-country]"));
        var groups = {};
        var grid = document.createElement("div");
        grid.className = "soksi-market-localization-grid";

        rows.forEach(function (row) {
          var key = row.getAttribute("data-market-key") || "default";
          var label = row.getAttribute("data-market-label") || key.toUpperCase();
          var order = parseInt(row.getAttribute("data-market-order"), 10);
          if (isNaN(order)) order = 90;

          if (!groups[key]) {
            var section = document.createElement("section");
            var heading = document.createElement("h3");
            var countryList = document.createElement("ul");

            section.className = "soksi-market-localization-market";
            heading.textContent = label;
            countryList.setAttribute("role", "list");
            section.appendChild(heading);
            section.appendChild(countryList);
            groups[key] = { section: section, list: countryList, label: label, order: order, count: 0 };
          }

          groups[key].count += 1;
          groups[key].list.appendChild(row);
        });

        Object.keys(groups)
          .sort(function (a, b) {
            if (groups[a].order !== groups[b].order) return groups[a].order - groups[b].order;
            return groups[a].label.localeCompare(groups[b].label);
          })
          .forEach(function (key) {
            var group = groups[key];
            group.section.setAttribute("data-market-country-count", String(group.count));
            if (group.count > 18) {
              group.section.classList.add("is-long");
            } else if (group.count <= 8) {
              group.section.classList.add("is-compact");
            }
            grid.appendChild(group.section);
          });

        list.innerHTML = "";
        list.appendChild(grid);
      }

      function openDialog() {
        if (typeof dialog.showModal === "function") {
          dialog.showModal();
        } else {
          dialog.setAttribute("open", "");
        }
        if (document.body) {
          document.body.classList.add("soksi-market-localization-open");
        }
      }

      function closeDialog() {
        if (typeof dialog.close === "function") {
          dialog.close();
        } else {
          dialog.removeAttribute("open");
        }
        if (document.body) {
          document.body.classList.remove("soksi-market-localization-open");
        }
      }

      openButton.addEventListener("click", function (event) {
        event.preventDefault();
        openDialog();
      });

      closeButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          closeDialog();
        });
      });

      dialog.addEventListener("click", function (event) {
        if (event.target === dialog) {
          closeDialog();
        }
      });

      dialog.addEventListener("close", function () {
        if (document.body) {
          document.body.classList.remove("soksi-market-localization-open");
        }
      });

      root.querySelectorAll("[data-soksi-market-localization-choice]").forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          var countryCode = button.getAttribute("data-country-code");
          var languageCode = button.getAttribute("data-language-code");
          if (!countryCode || !languageCode) return;

          countryInput.value = countryCode;
          languageInput.value = languageCode;
          form.submit();
        });
      });
    });
  }

  function setupMiniCart() {
    var miniCartRequestId = 0;

    function getMiniCartWraps() {
      return Array.prototype.slice.call(document.querySelectorAll(".soksi-bag-wrap"));
    }

    function getMiniCartSectionId() {
      var wrap = document.querySelector(".soksi-bag-wrap");
      var section = wrap ? closest(wrap, ".shopify-section") : null;
      var sectionId = section && section.id ? section.id : "";

      return sectionId.replace(/^shopify-section-/, "");
    }

    function buildMiniCartSectionUrl(sectionId) {
      var url = new URL(window.location.href);
      url.searchParams.set("section_id", sectionId);
      return url.toString();
    }

    function buildAjaxCartUrl(urlLike) {
      var url = new URL(urlLike, window.location.origin);
      if (!/\.js$/.test(url.pathname)) {
        url.pathname = url.pathname.replace(/\/$/, "") + ".js";
      }
      return url.toString();
    }

    function extractMiniCartWrap(sectionHtml) {
      var doc = document.implementation.createHTMLDocument("");
      doc.body.innerHTML = sectionHtml;
      return doc.querySelector(".soksi-bag-wrap");
    }

    function applyMiniCartMarkup(nextWrap, shouldOpen) {
      if (!nextWrap) return;

      getMiniCartWraps().forEach(function (wrap) {
        var keepOpen = shouldOpen || wrap.classList.contains("is-open");
        wrap.innerHTML = nextWrap.innerHTML;
        wrap.classList.toggle("is-open", keepOpen);
      });
    }

    function syncMiniCartFromSection(shouldOpen) {
      var sectionId = getMiniCartSectionId();
      if (!sectionId) return Promise.resolve();

      miniCartRequestId += 1;
      var requestId = miniCartRequestId;

      return fetch(buildMiniCartSectionUrl(sectionId), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Unable to refresh mini cart section");
          }
          return response.text();
        })
        .then(function (sectionHtml) {
          if (requestId !== miniCartRequestId) return;

          var nextWrap = extractMiniCartWrap(sectionHtml);
          if (!nextWrap) {
            throw new Error("Mini cart markup missing from section response");
          }

          applyMiniCartMarkup(nextWrap, shouldOpen);
        })
        .catch(function (error) {
          console.error("Failed to sync Soksi mini cart:", error);
        });
    }

    function removeMiniCartItem(removeUrl) {
      return fetch(buildAjaxCartUrl(removeUrl), {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Unable to remove item from cart");
          }
          return response.json();
        })
        .then(function () {
          return syncMiniCartFromSection(true);
        })
        .catch(function (error) {
          console.error("Failed to remove Soksi mini cart item:", error);
        });
    }

    document.addEventListener("click", function (event) {
      var removeTrigger = closest(event.target, ".soksi-mini-remove");
      if (removeTrigger) {
        event.preventDefault();
        removeMiniCartItem(removeTrigger.getAttribute("href"));
        return;
      }

      var trigger = closest(event.target, "[data-soksi-bag-button]");
      if (trigger) {
        var wrap = closest(trigger, ".soksi-bag-wrap");
        if (!wrap || window.matchMedia("(min-width: 990px)").matches) return;

        event.preventDefault();
        wrap.classList.toggle("is-open");
        return;
      }

      getMiniCartWraps().forEach(function (wrap) {
        if (!closest(event.target, ".soksi-bag-wrap")) {
          wrap.classList.remove("is-open");
        }
      });
    });

    document.addEventListener("cart:update", function (event) {
      var detail = event && event.detail ? event.detail : null;
      var data = detail && detail.data ? detail.data : null;
      var shouldOpen = !!(data && data.source === "product-form-component");

      syncMiniCartFromSection(shouldOpen);
    });
  }

  function setupAccountPanel() {
    var wrap = document.querySelector("[data-soksi-account-wrap]");
    if (!wrap) return;

    var trigger = wrap.querySelector("[data-soksi-account-trigger]");
    if (!trigger) return;

    function open() {
      wrap.classList.add("is-open");
      document.documentElement.classList.add("account-out");
    }

    function close() {
      wrap.classList.remove("is-open");
      document.documentElement.classList.remove("account-out");
    }

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      if (wrap.classList.contains("is-open")) {
        close();
      } else {
        open();
      }
    });

    wrap.addEventListener("mouseenter", open);
    wrap.addEventListener("mouseleave", close);

    document.addEventListener("click", function (event) {
      if (!closest(event.target, "[data-soksi-account-wrap]")) {
        close();
      }
    });
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add("attivo");
    overlay.setAttribute("aria-hidden", "false");
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove("attivo");
    overlay.setAttribute("aria-hidden", "true");

    if (overlay.hasAttribute("data-soksi-newsletter-popup")) {
      setPopupFlag(
        NEWSLETTER_DISMISSED_COOKIE,
        parseInteger(overlay.getAttribute("data-dismiss-duration-days"), 7)
      );
    }
  }

  function setupOverlays() {
    document.querySelectorAll("[data-soksi-open-overlay]").forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var id = trigger.getAttribute("data-soksi-open-overlay");
        if (!id) return;
        var overlay = document.getElementById(id);
        if (!overlay) return;
        openOverlay(overlay);
      });
    });

    document.querySelectorAll("[data-soksi-close-overlay]").forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var overlay = closest(trigger, ".soksi-overlay");
        closeOverlay(overlay);
      });
    });

    document.querySelectorAll(".soksi-overlay").forEach(function (overlay) {
      overlay.addEventListener("click", function (event) {
        if (event.target === overlay) {
          closeOverlay(overlay);
        }
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      document.querySelectorAll(".soksi-overlay.attivo").forEach(function (overlay) {
        closeOverlay(overlay);
      });
    });
  }

  function setupNewsletterPopup() {
    var overlay = document.querySelector("[data-soksi-newsletter-popup]");
    if (!overlay) return;

    var resultNode = overlay.querySelector("[data-soksi-newsletter-result]");
    var result = resultNode ? resultNode.getAttribute("data-soksi-newsletter-result") : "";

    if (result === "success") {
      setPopupFlag(
        NEWSLETTER_SUBMITTED_COOKIE,
        parseInteger(overlay.getAttribute("data-submitted-duration-days"), 365)
      );
      openOverlay(overlay);
      return;
    }

    if (result === "error") {
      openOverlay(overlay);
      return;
    }

    if (!parseBoolean(overlay.getAttribute("data-auto-popup-enabled"), true)) return;
    if (parseBoolean(overlay.getAttribute("data-auto-popup-suppressed"), false)) return;
    if (hasPopupFlag(NEWSLETTER_DISMISSED_COOKIE) || hasPopupFlag(NEWSLETTER_SUBMITTED_COOKIE)) return;

    var openedAutomatically = false;
    var timerId = null;
    var pageType = overlay.getAttribute("data-page-type");
    var isProductPage = pageType === "product";
    var delayAttribute = isProductPage ? "data-auto-popup-product-delay" : "data-auto-popup-delay";
    var delayFallback = isProductPage ? 15000 : 10000;
    var delay = Math.max(0, parseInteger(overlay.getAttribute(delayAttribute), delayFallback));
    var scrollTriggerEnabled = parseBoolean(overlay.getAttribute("data-scroll-trigger-enabled"), true);
    var scrollTriggerPercentage = Math.min(
      90,
      Math.max(10, parseInteger(overlay.getAttribute("data-scroll-trigger-percentage"), 50))
    );
    var exitIntentEnabled = parseBoolean(overlay.getAttribute("data-exit-intent-enabled"), true);
    var desktopExitIntent = window.matchMedia
      ? window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)")
      : null;

    function cleanupAutoTriggers() {
      if (timerId !== null) {
        window.clearTimeout(timerId);
        timerId = null;
      }
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onExitIntent);
      window.removeEventListener("pagehide", cleanupAutoTriggers);
    }

    function hasReachedScrollDepth() {
      var root = document.documentElement;
      var body = document.body;
      var viewportHeight = window.innerHeight || root.clientHeight || 0;
      var pageHeight = Math.max(root.scrollHeight, body ? body.scrollHeight : 0);
      var scrollableHeight = pageHeight - viewportHeight;
      if (scrollableHeight <= 0) return false;

      var scrollTop = window.pageYOffset || root.scrollTop || (body ? body.scrollTop : 0) || 0;
      return (scrollTop / scrollableHeight) * 100 >= scrollTriggerPercentage;
    }

    function tryOpenAutomatically() {
      if (openedAutomatically) return false;
      if (hasPopupFlag(NEWSLETTER_DISMISSED_COOKIE) || hasPopupFlag(NEWSLETTER_SUBMITTED_COOKIE)) return;
      if (document.querySelector(".soksi-overlay.attivo")) return;

      openedAutomatically = true;
      cleanupAutoTriggers();
      openOverlay(overlay);
      return true;
    }

    function onScroll() {
      if (hasReachedScrollDepth()) {
        tryOpenAutomatically();
      }
    }

    function onExitIntent(event) {
      if (!desktopExitIntent || !desktopExitIntent.matches) return;
      if (event.relatedTarget || event.toElement) return;
      if (event.clientY > 0) return;
      tryOpenAutomatically();
    }

    timerId = window.setTimeout(tryOpenAutomatically, delay);

    if (scrollTriggerEnabled) {
      window.addEventListener("scroll", onScroll, { passive: true });
      window.requestAnimationFrame(onScroll);
    }

    if (exitIntentEnabled && desktopExitIntent && desktopExitIntent.matches) {
      document.addEventListener("mouseout", onExitIntent);
    }

    window.addEventListener("pagehide", cleanupAutoTriggers, { once: true });
  }

  function setupAccordions() {
    document.querySelectorAll("[data-soksi-accordion-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var target = trigger.getAttribute("data-soksi-accordion-trigger");
        if (!target) return;
        var body = document.getElementById(target);
        if (!body) return;
        var isCollapsed = body.classList.contains("is-collapsed");
        body.classList.toggle("is-collapsed");
        trigger.setAttribute("aria-expanded", String(isCollapsed));
      });
    });
  }

  function setupHeaderTicker() {
    var wrapper = document.querySelector("[data-soksi-topinfos]");
    if (!wrapper) return;

    var items = Array.prototype.slice.call(wrapper.querySelectorAll("[data-soksi-topinfo-item]"));
    if (!items.length) return;
    var intervalMs = parseInt(wrapper.getAttribute("data-soksi-topinfo-interval"), 10);
    if (!Number.isFinite(intervalMs) || intervalMs < 1000) {
      intervalMs = 5000;
    }

    var index = 0;
    items.forEach(function (item, idx) {
      var active = idx === 0;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-hidden", active ? "false" : "true");
    });

    if (items.length < 2) return;

    window.setInterval(function () {
      var current = items[index];
      index = (index + 1) % items.length;
      var next = items[index];

      current.classList.remove("is-active");
      current.setAttribute("aria-hidden", "true");
      next.classList.add("is-active");
      next.setAttribute("aria-hidden", "false");
    }, intervalMs);
  }

  function setupDesktopMenuBandHeights() {
    var menuCols = Array.prototype.slice.call(document.querySelectorAll(".soksi-menu-col"));
    if (!menuCols.length) return;

    var desktopQuery = window.matchMedia("(min-width: 990px)");

    function measureSubmenuHeight(submenu) {
      var previousDisplay = submenu.style.display;
      var previousVisibility = submenu.style.visibility;
      var previousPointerEvents = submenu.style.pointerEvents;

      submenu.style.display = "block";
      submenu.style.visibility = "hidden";
      submenu.style.pointerEvents = "none";
      var height = submenu.offsetHeight;

      submenu.style.display = previousDisplay;
      submenu.style.visibility = previousVisibility;
      submenu.style.pointerEvents = previousPointerEvents;
      return height;
    }

    function applyBandHeights() {
      if (!desktopQuery.matches) {
        menuCols.forEach(function (col) {
          col.style.removeProperty("--soksi-menu-band-height");
        });
        return;
      }

      menuCols.forEach(function (col) {
        var submenu = col.querySelector(".soksi-submenu");
        if (!submenu) return;
        var height = measureSubmenuHeight(submenu);
        if (height > 0) {
          col.style.setProperty("--soksi-menu-band-height", height + "px");
        }
      });
    }

    applyBandHeights();
    window.addEventListener("resize", applyBandHeights);

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", applyBandHeights);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(applyBandHeights);
    }
  }

  function setupCookiePreferences() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll("[data-soksi-cookie-preferences]"));
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
        if (customerPrivacy && typeof customerPrivacy.showPreferences === "function") {
          customerPrivacy.showPreferences();
        }
      });
    });
  }

  function setupFooterLogoDocking() {
    var footer = document.querySelector(".soksi-footer");
    var logoContainer = document.querySelector("[data-soksi-docking-logo]");
    if (!footer || !logoContainer) return;
    var logo = logoContainer.querySelector(".soksi-footer-logo");
    if (!logo) return;

    var desktopQuery = window.matchMedia("(min-width: 990px)");
    var isDocked = null;
    var ticking = false;

    function applyDocking(inFooter) {
      if (!desktopQuery.matches) {
        logoContainer.classList.add("is-in-footer");
        logo.style.transition = "";
        logo.style.transform = "";
        isDocked = true;
        return;
      }

      if (isDocked === inFooter) return;

      var first = logo.getBoundingClientRect();
      logoContainer.classList.toggle("is-in-footer", inFooter);
      var last = logo.getBoundingClientRect();
      var dx = first.left - last.left;
      var dy = first.top - last.top;

      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) {
        isDocked = inFooter;
        return;
      }

      logo.style.transition = "none";
      logo.style.transform = "translate(" + dx + "px," + dy + "px)";
      logo.getBoundingClientRect();

      window.requestAnimationFrame(function () {
        logo.style.transition = "transform 320ms cubic-bezier(0.22, 1, 0.36, 1)";
        logo.style.transform = "translate(0,0)";
      });

      var cleanTransition = function () {
        logo.style.transition = "";
        logo.style.transform = "";
        logo.removeEventListener("transitionend", cleanTransition);
      };
      logo.addEventListener("transitionend", cleanTransition);
      isDocked = inFooter;
    }

    function footerInDockingZone() {
      var rect = footer.getBoundingClientRect();
      return rect.bottom > 0 && rect.top <= window.innerHeight - 65;
    }

    function sync() {
      ticking = false;
      applyDocking(footerInDockingZone());
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }

    requestSync();
    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync);

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", requestSync);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(requestSync);
    }
  }

  function setupCollectionPoseShuffle() {
    var main = document.getElementById("MainContent");
    if (!main) return;

    var template = main.getAttribute("data-template") || "";
    if (template.indexOf("collection") === -1) return;

    var resultsList = document.querySelector("results-list");
    var randomProductsEnabled = parseBoolean(
      resultsList && resultsList.getAttribute("data-soksi-random-products"),
      true
    );
    var randomImagesEnabled = parseBoolean(resultsList && resultsList.getAttribute("data-soksi-random-images"), true);

    var grid =
      document.querySelector("#ResultsList [ref='grid']") ||
      document.querySelector("results-list [ref='grid']") ||
      document.querySelector(".soksi-products") ||
      document.querySelector(".product-grid");

    if (!grid) return;

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll(":scope > [ref='cards[]'], :scope > .soksi-product-card, :scope > .product-grid__item")
    );
    if (!cards.length) return;

    var sortBy = new URL(window.location.href).searchParams.get("sort_by");
    var hasExplicitSort = Boolean(sortBy && sortBy !== "manual");

    if (randomProductsEnabled && !hasExplicitSort) {
      shuffleInPlace(cards);
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    if (!randomImagesEnabled) return;

    cards = Array.prototype.slice.call(
      grid.querySelectorAll(":scope > [ref='cards[]'], :scope > .soksi-product-card, :scope > .product-grid__item")
    );

    var columns = getGridColumnCount(grid);

    for (var start = 0; start < cards.length; start += columns) {
      var rowCards = cards.slice(start, start + columns);
      var usedPoseIndexes = new Set();

      rowCards.forEach(function (card) {
        var slideshow = card.querySelector("slideshow-component");

        if (slideshow) {
          var visibleSlides = Array.prototype.slice.call(slideshow.querySelectorAll("slideshow-slide:not([hidden])"));
          var maxVisiblePool = Math.min(3, visibleSlides.length);

          if (maxVisiblePool > 1) {
            var candidateVisibleIndexes = [];
            for (var visibleIndex = 0; visibleIndex < maxVisiblePool; visibleIndex += 1) {
              candidateVisibleIndexes.push(visibleIndex);
            }
            shuffleInPlace(candidateVisibleIndexes);

            var selectedVisibleIndex = candidateVisibleIndexes[0];
            for (var candidateIdx = 0; candidateIdx < candidateVisibleIndexes.length; candidateIdx += 1) {
              if (!usedPoseIndexes.has(candidateVisibleIndexes[candidateIdx])) {
                selectedVisibleIndex = candidateVisibleIndexes[candidateIdx];
                break;
              }
            }
            usedPoseIndexes.add(selectedVisibleIndex);

            var selectedVisibleSlide = visibleSlides[selectedVisibleIndex];
            if (!selectedVisibleSlide) return;

            var allSlides = Array.prototype.slice.call(slideshow.querySelectorAll("slideshow-slide"));
            var absoluteSlideIndex = allSlides.indexOf(selectedVisibleSlide);
            if (absoluteSlideIndex < 0) return;

            slideshow.setAttribute("initial-slide", String(absoluteSlideIndex));

            var slideId = selectedVisibleSlide.getAttribute("slide-id");
            if (slideId && typeof slideshow.select === "function") {
              try {
                slideshow.select({ id: slideId }, undefined, { animate: false });
              } catch (err) {
                // Best-effort; the initial-slide attribute still sets the pose once the component is ready.
              }
            }

            return;
          }
        }

        var img = card.querySelector(".soksi-product-card-media img");
        if (!img) return;

        var pool = parseJson(card.getAttribute("data-soksi-image-pool"));
        if (!Array.isArray(pool) || pool.length === 0) return;

        var fallbackPoolSize = Math.min(3, pool.length);
        var indexes = [];
        for (var poolIndex = 0; poolIndex < fallbackPoolSize; poolIndex += 1) {
          indexes.push(poolIndex);
        }
        shuffleInPlace(indexes);

        var selected = indexes[0];
        for (var idx = 0; idx < indexes.length; idx += 1) {
          if (!usedPoseIndexes.has(indexes[idx])) {
            selected = indexes[idx];
            break;
          }
        }

        usedPoseIndexes.add(selected);

        var selectedSrc = pool[selected];
        if (!selectedSrc) return;

        img.setAttribute("src", selectedSrc);
        img.setAttribute("srcset", "");
      });
    }
  }

  function setupProductColourPrefetch() {
    var main = document.getElementById("MainContent");
    if (!main) return;

    var template = main.getAttribute("data-template") || "";
    if (template.indexOf("product") === -1) return;

    var links = Array.prototype.slice.call(document.querySelectorAll("[data-soksi-product-prefetch]"));
    if (!links.length) return;

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var shouldAvoidIdlePrefetch =
      Boolean(connection && connection.saveData) ||
      Boolean(connection && /(^|-)2g$/.test(connection.effectiveType || ""));

    var prefetchedPages = {};
    var prefetchedImages = {};
    var maxIdleItems = 6;
    var maxPrefetchedPages = 18;
    var maxPrefetchedImages = 18;
    var prefetchedPageCount = 0;
    var prefetchedImageCount = 0;

    function toAbsoluteUrl(rawUrl) {
      if (!rawUrl) return "";

      try {
        return new URL(rawUrl, window.location.href).href;
      } catch (err) {
        return "";
      }
    }

    function isCurrentProductUrl(url) {
      try {
        return new URL(url).pathname === window.location.pathname;
      } catch (err) {
        return false;
      }
    }

    function appendPrefetchLink(url, asType) {
      var link = document.createElement("link");
      link.rel = "prefetch";
      link.href = url;
      if (asType) {
        link.as = asType;
      }
      link.fetchPriority = "low";
      document.head.appendChild(link);
    }

    function prefetchImage(url, immediate) {
      if (!url || prefetchedImages[url] || prefetchedImageCount >= maxPrefetchedImages) return;

      prefetchedImages[url] = true;
      prefetchedImageCount += 1;

      if (immediate) {
        var image = new Image();
        image.decoding = "async";
        image.src = url;
        return;
      }

      appendPrefetchLink(url, "image");
    }

    function prefetchProduct(link, immediate) {
      var productUrl = toAbsoluteUrl(link.getAttribute("href"));
      if (!productUrl || isCurrentProductUrl(productUrl)) return;

      if (!prefetchedPages[productUrl] && prefetchedPageCount < maxPrefetchedPages) {
        prefetchedPages[productUrl] = true;
        prefetchedPageCount += 1;
        appendPrefetchLink(productUrl, "document");
      }

      prefetchImage(toAbsoluteUrl(link.getAttribute("data-soksi-prefetch-image")), immediate);
    }

    function prefetchBatch() {
      var prefetched = 0;

      links.some(function (link) {
        if (prefetched >= maxIdleItems) return true;
        if (isCurrentProductUrl(toAbsoluteUrl(link.getAttribute("href")))) return false;

        prefetchProduct(link, false);
        prefetched += 1;
        return false;
      });
    }

    function scheduleIdlePrefetch() {
      if (shouldAvoidIdlePrefetch) return;

      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(prefetchBatch, { timeout: 2000 });
      } else {
        window.setTimeout(prefetchBatch, 700);
      }
    }

    links.forEach(function (link) {
      ["pointerenter", "focus", "mousedown", "touchstart"].forEach(function (eventName) {
        link.addEventListener(
          eventName,
          function () {
            prefetchProduct(link, true);
          },
          { passive: true }
        );
      });
    });

    var root = document.querySelector("[data-soksi-product-prefetch-root]");
    if (!root || !("IntersectionObserver" in window)) {
      scheduleIdlePrefetch();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;

        observer.disconnect();
        scheduleIdlePrefetch();
      },
      { rootMargin: "250px 0px" }
    );

    observer.observe(root);
  }

  function setupAutoScroll() {
    if (document.documentElement.classList.contains("shopify-design-mode")) return;

    var main = document.getElementById("MainContent");
    if (!main) return;

    var template = main.getAttribute("data-template") || "";
    var isDesktop = window.matchMedia("(min-width: 990px)").matches;
    var isCollectionTemplate = template.indexOf("collection") > -1;
    var collectionAutoScrollEnabled = true;

    if (isCollectionTemplate) {
      var collectionResultsList = document.querySelector("results-list");
      collectionAutoScrollEnabled = parseBoolean(
        collectionResultsList && collectionResultsList.getAttribute("data-soksi-auto-scroll"),
        true
      );
    }

    var isEligibleTemplate =
      template.indexOf("index") > -1 ||
      (isCollectionTemplate && collectionAutoScrollEnabled) ||
      template.indexOf("page.lookbook") > -1 ||
      (template.indexOf("product") > -1 && isDesktop);

    if (!isEligibleTemplate) return;

    var stopped = false;
    var animationFrame = null;
    var resumeTimeout = null;
    var previousTimestamp = 0;
    var autoScrollTop = window.scrollY;
    var speed = isDesktop ? 50 : 40;
    var shouldResumeAfterUserInput = true;
    var USER_RESUME_DELAY = isCollectionTemplate ? 5000 : 3000;
    var userInputEvents = ["wheel", "touchstart", "touchmove", "mousedown", "keydown"];

    function setAutoScrollActive(isActive) {
      document.documentElement.classList.toggle("soksi-auto-scrolling", isActive);
    }

    function hasBlockingUi() {
      return Boolean(
        document.documentElement.classList.contains("menuout") ||
          document.documentElement.classList.contains("account-out") ||
          document.documentElement.hasAttribute("scroll-lock") ||
          document.querySelector(".soksi-overlay.attivo") ||
          document.querySelector(".soksi-bag-wrap.is-open") ||
          document.querySelector("#filters-drawer dialog[open]") ||
          document.querySelector("dialog.dialog-modal[open]")
      );
    }

    function isAtPageEnd() {
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      return maxScroll <= 0 || window.scrollY >= maxScroll - 1;
    }

    function pauseAutoScroll() {
      setAutoScrollActive(false);
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      previousTimestamp = 0;
      autoScrollTop = window.scrollY;
    }

    function startAutoScroll() {
      if (stopped || animationFrame || isAtPageEnd()) return;
      previousTimestamp = 0;
      autoScrollTop = window.scrollY;
      setAutoScrollActive(true);
      animationFrame = window.requestAnimationFrame(tick);
    }

    function stopAutoScroll() {
      stopped = true;
      if (resumeTimeout) {
        window.clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }
      pauseAutoScroll();
      userInputEvents.forEach(function (eventName) {
        document.removeEventListener(eventName, onUserInput);
      });
    }

    function onUserInput() {
      if (!shouldResumeAfterUserInput) {
        stopAutoScroll();
        return;
      }

      pauseAutoScroll();
      if (resumeTimeout) {
        window.clearTimeout(resumeTimeout);
      }

      resumeTimeout = window.setTimeout(function () {
        resumeTimeout = null;
        startAutoScroll();
      }, USER_RESUME_DELAY);
    }

    function tick(timestamp) {
      if (stopped) return;

      if (previousTimestamp === 0) previousTimestamp = timestamp;

      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll <= 0) {
        stopAutoScroll();
        return;
      }

      var delta = (timestamp - previousTimestamp) / 1000;
      previousTimestamp = timestamp;

      if (!hasBlockingUi()) {
        autoScrollTop = Math.max(autoScrollTop, window.scrollY);
        var target = Math.min(maxScroll, autoScrollTop + speed * delta);
        autoScrollTop = target;
        window.scrollTo({ left: 0, top: Math.round(target), behavior: "auto" });
        if (target >= maxScroll - 1) {
          stopAutoScroll();
          return;
        }
      }

      animationFrame = window.requestAnimationFrame(tick);
    }

    userInputEvents.forEach(function (eventName) {
      document.addEventListener(eventName, onUserInput, { passive: true });
    });

    window.setTimeout(function () {
      startAutoScroll();
    }, 300);
  }

  ready(function () {
    setupMobileMenu();
    setupLocalizationDropdown();
    setupLocalizationRecommendation();
    setupMarketLocalizationModal();
    setupMiniCart();
    setupAccountPanel();
    setupOverlays();
    setupNewsletterPopup();
    setupAccordions();
    setupHeaderTicker();
    setupDesktopMenuBandHeights();
    setupCookiePreferences();
    setupFooterLogoDocking();
    setupCollectionPoseShuffle();
    setupProductColourPrefetch();
    setupAutoScroll();
  });
})();
